import React from 'react';
import {
  Skeleton,
  Grid
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import ArticleBodySkeleton from './ArticleBodySkeleton';

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: '8rem',
    marginTop: '-1rem',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '4rem'
    }
  },
  image: {
    [theme.breakpoints.down('sm')]: {
      // margin: '0 auto'
    }
  },
  line: {
    height: 40,
    marginBottom: 20
  },
  item: {
    height: 80,
    marginBottom: 10
  },
  tags: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    }
  }
}));

export default function ArticleSkeleton () {
  const classes = useStyles();
  return (
    <>
      <Grid
        container
        direction='row'
        justifyContent='flex-start'
        alignItems='flex-start'
        spacing={{ xs: 1, sm: 1 }}
        className={classes.header}
      >
        <Grid item sm={3} className={classes.image}>
          <Skeleton variant='circular' sx={{ height: 200, width: 200 }} />
        </Grid>
        <Grid item sm={7}>
          <div className={classes.tags}>
            <Skeleton variant='rectangle' className={classes.line} />
            <Skeleton variant='rectangle' className={classes.line} />
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        direction='row'
        justifyContent='space-between'
        alignItems='flex-start'
        spacing={{ xs: 1, sm: 3 }}
      >
        <Grid item sm={4}>
          <Skeleton variant='rectangle' className={classes.item} />
          <Skeleton variant='rectangle' className={classes.item} />
          <Skeleton variant='rectangle' className={classes.item} />
          <Skeleton variant='rectangle' className={classes.item} />
        </Grid>
        <Grid item sm={8}>
          <ArticleBodySkeleton />
        </Grid>
      </Grid>
    </>
  );
}
